3. <template>
    <div>
        <video ref="video" @canplay="initCanvas()">Stream unavailable</video>
        <canvas ref='canvas' style='display:none;' />
        <button @click="takePhoto()">Take Photo</button>
        <timer-settings @start-timer="startTimer" />
        <p>Countdown:{{ countdown }} seconds</p>
        <photo-preview v-if="capturedPhoto" :photo="capturedPhoto" />
    </div>
</template>

<script>
// import CameraPhoto from "html5-camera-photo";
import EventBus from "../../event-bus";
import TimerSettings from "./TimerSettings.vue";
import PhotoPreview from "./PhotoPreview.vue";
export default {
 data() {
    return {
        capturedPhoto: null,
        canvas:null,
        video:null,
        timerDuration: 0,
        countdown:0,
    };
 },
mounted() {
    this.canvas = this.$refs.canvas;
    this.video = this.$refs.video;
	this.startCapture();
},
 methods: {
    startCapture(){
        navigator.mediaDevices.getUserMedia(
            {video:true, audio:false}
        ).then(stream=>{
            this.video.srcObject = stream;
            this.video.play();
        }).catch(error=>{
            console.log(error);
        })
    },
    initCanvas() {
        this.canvas.setAttribute('width', this.video.videoWidth);
        this.canvas.setAttribute('height', this.video.videoheight);
    },
    async takePhoto() {
        //   const cameraPhoto = new CameraPhoto(this.$refs.video);
        //   const dataUri = await cameraPhoto.getDataUri();
        //   this.capturedPhoto = dataUri;
        let context = this.canvas.getContext('2d');
            context.drawImage(this.video, 0, 0, this.video.videoWidth, this.video.videoHeight);
        EventBus.$emit('picture-taken',
            {image:this.canvas.toDataURL('image/png'),
            width:this.video.videoWidth,
            height:this.video.videoHeight}
        );
    },
    startTimer(duration) {
      this.timerDuration = duration;
    this.countdown = duration;
    //   setTimeout(() => {
    //     this.takePhoto();
    //   }, this.timerDuration * 1000);
    const timerInterval = setInterval(() => {
      this.countdown--; // Decrement the countdown
      if (this.countdown <= 0) {
        clearInterval(timerInterval); // Clear the interval when countdown reaches 0
        this.takePhoto();
      }
    }, 1000); // Update countdown every 1 second
    },

  },
  components: {
    TimerSettings,
    PhotoPreview,
  },
};
</script>

<style>
/* Style the camera video element */
video {
  max-width: 100%;
}
</style>
